import { FC, useMemo } from 'react';
import { LocalAccountsInsights } from '../../../types/LocalAccountsInsights';
import { DonutChart, HexColor, LayoutCarousel } from '@silverfort/sf-components';
import { LocalAccountType } from '../../../types/LocalAccount';

interface Props {
    localAccountsInsights?: LocalAccountsInsights;
    isLoading: boolean;
}

const MINIMUM_VALUE = 0.1;

const toDonutChartItem = (name: string, value: number, total: number, fill: string, isNoLocalAccounts: boolean, tooltipName?: string) => {
    return {
        name,
        value,
        fill: isNoLocalAccounts ? '#F6F6F6' as HexColor : fill as HexColor,
        formattedValue: (isNoLocalAccounts || value === 0) ? '0' : `${Math.max(
            Math.floor((value / total) * 100),
            MINIMUM_VALUE
        )}%`,
        tooltipContent: `${tooltipName || name} accounts: ${value}`
    }; 
}

const LocalAccountAccessTypesCard: FC<Props> = ({ localAccountsInsights, isLoading }) => {
    const localAccountAccessTypes = useMemo(() => {
        const isNoLocalAccounts = !localAccountsInsights?.totalLocalAccounts;
        const totalLocalAccounts = localAccountsInsights?.totalLocalAccounts || 1;
        const totalAdminAccounts = localAccountsInsights?.accountTypeToCountMap[LocalAccountType.ADMINISTRATOR] || 0;
        const totalUserAccounts = localAccountsInsights?.accountTypeToCountMap[LocalAccountType.USER] || 0;
        const totalGuestAccounts = localAccountsInsights?.accountTypeToCountMap[LocalAccountType.GUEST] || 0;

        return [
            toDonutChartItem('Admin', totalAdminAccounts, totalLocalAccounts, '#1C89AC' as HexColor, isNoLocalAccounts, 'Administrator'),
            toDonutChartItem('User', totalUserAccounts, totalLocalAccounts, '#50017A' as HexColor, isNoLocalAccounts),
            toDonutChartItem('Guest', totalGuestAccounts, totalLocalAccounts, '#FF115B' as HexColor, isNoLocalAccounts)
        ];
    }, [localAccountsInsights]);
    
    return (
        <LayoutCarousel
            title="Account type"
            contentClassName="flex flex-1 flex-col justify-center px-6"
            pages={<DonutChart data={localAccountAccessTypes} isMappingVisible isLoading={isLoading} />}
        />
    );
};

export default LocalAccountAccessTypesCard;
